import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M17.517 16.457a8.5 8.5 0 1 0-1.06 1.06l4.013 4.013a.75.75 0 1 0 1.06-1.06zM11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }